import styled from 'styled-components/macro'
import {
  FilterBarWrapper,
  FilterSearchContainer,
} from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.styles'
import { SearchContainer } from 'src/components/Reusable/Search/Search.styles'
import { ContextTypeSelectorContainer } from '../chatContextPanel.styles'

export const EvidenceSelectorContainer = styled(ContextTypeSelectorContainer)`
  justify-content: center;
`

export const EvidenceFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 8px 0;
  width: 100%;

  ${FilterSearchContainer} {
    flex-wrap: wrap;
    align-items: center;
    row-gap: 8px;

    ${SearchContainer} {
      width: auto;
      max-width: 100%;
      min-width: 280px;
      flex: 1 1 320px;
      margin-left: auto;
    }
  }

  ${FilterBarWrapper} {
    flex-wrap: wrap;
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
  }
`
